import { responsiveVariables } from "../../../utilities/props.js";
import "./justify.css";
const justify = (value) => {
    if (!value)
        return {};
    return {
        variables: responsiveVariables("--rs-justify", value),
    };
};
export default justify;
